import { Transform, TransformFnParams, Type } from 'class-transformer';

import { MyInfoAddressNonSG, MyInfoAddressSG, MyInfoAddressType } from '../model';

export function FlattenObject(key: string, typeFn?: () => any) {
  const transformDecorator = Transform((params: TransformFnParams) => {
    const { value, obj } = params;

    // If key contains dot, treat it as a path from the root object (obj)
    if (key.includes('.')) {
      const parts = key.split('.');
      let v: any = obj;
      for (const part of parts) {
        v = v?.[part];
        if (v === undefined) break;
      }
      return v ?? value;
    }

    // Otherwise, pick from the property's value (common case: value/code)
    return value?.[key] ?? value;
  });

  if (!typeFn) return transformDecorator;

  const typeDecorator = Type(typeFn);

  return (target: any, propertyKey: string) => {
    transformDecorator(target, propertyKey);
    typeDecorator(target, propertyKey);
  };
}

export function MyInfoAddress() {
  return Type(() => Object, {
    keepDiscriminatorProperty: true as const,
    discriminator: {
      property: 'type' as const,
      subTypes: [
        { value: MyInfoAddressSG, name: 'SG' } as const,
        { value: MyInfoAddressNonSG, name: 'UNFORMATTED' } as const,
      ],
    },
  });
}

export function isMyInfoAddressSG(address: MyInfoAddressSG | MyInfoAddressNonSG): address is MyInfoAddressSG {
  return address?.type === MyInfoAddressType.SG;
}
